import axios from 'axios';

const state = {
  uniFilters: {},
  selectedStudentUniversity: null,
};

const getters = {
  getUniFilters: state => state.uniFilters,
  getSelectedStudentUniversity: state => state.selectedStudentUniversity,
};

const mutations = {
  updateUniFilters: (state, updatedFilters) => {
    state.uniFilters = { ...state.uniFilters, ...updatedFilters };
  },
  updateSelectedStudentUniversity: (state, university) => {
    state.selectedStudentUniversity = university;
  },
};

const actions = {
  async getAllUnis(_obj, params) {
    const res = await axios.get(`api/universities/`, { params });
    return res.data;
  },

  async getUni(_obj, id) {
    const res = await axios.get(`api/universities/${id}/`);
    return res.data;
  },

  async getUniFromSlug(_obj, slug) {
    const res = await axios.get(`api/universities/public-university-retrieve/`, { params: { slug } });
    return res.data;
  },

  async createUni(_obj, data) {
    return axios.post(`api/universities/`, data);
  },

  async updateUni(_obj, { id, data }) {
    return axios.patch(`api/universities/${id}/`, data);
  },

  async deleteUni(_obj, id) {
    return axios.delete(`api/universities/${id}/`);
  },

  async getUniImageUploadPresignedUrl(_obj, data) {
    return (await axios.post(`api/universities/image-upload-url/`, data)).data.data;
  },

  async getAllPartneredUniversities(_obj, params) {
    const res = await axios.get(`api/universities/school-partnered-universities/`, { params });
    return res.data;
  },

  async getAllUniversitiesForStd(_obj, params) {
    const res = await axios.get(`api/universities/student-portal-universities/`, { params });
    return res.data;
  },

  // Program counts by state for a destination program (public, same as the site).
  async getProgramGeoCounts(_obj, params) {
    const res = await axios.get(`api/universities/program-geo-counts/`, { params });
    return res.data;
  },

  async getAllUniversitiesByState(_obj, params) {
    const res = await axios.get(`api/universities/public-university-list/`, { params });

    return res.data;
  },

  async getAllUniversities(_obj, params) {
    const res = await axios.get(`api/universities/student-university-list/`, { params });
    return res.data;
  },

  // One school's offering of one program, with admission facts (public program page).
  async getPublicUniOfferedProgram(_obj, params) {
    const res = await axios.get(`api/universities/uni-offered-programs/`, { params });
    return res.data;
  },

  async getAllUniOfferedPrograms(_obj, params) {
    const res = await axios.get(`api/universities/offered-programs/`, { params });
    return res.data;
  },

  async getFavUniversities(_obj, params) {
    const res = await axios.get(`api/universities/student-favourite-list/`, { params });
    return res.data;
  },

  async updateFavStatus(_obj, data) {
    return axios.patch(`api/universities/favourite-status/`, data);
  },

  async updateUniFilters({ commit }, { filters }) {
    commit('updateUniFilters', filters);
  },

  async setSelectedStudentUniversity({ commit }, university) {
    commit('updateSelectedStudentUniversity', university || null);
  },

  async getMinMaxTuition(_obj, params) {
    const res = await axios.get(`api/universities/min-max-tuition-fee/`, { params });
    return res.data;
  },

  async getUniversityChecklistConfigExtra(_obj, { checklist_config_id }) {
    const res = await axios.get(`api/universities/checklist-config-extra/`, {
      params: { checklist_config_id },
    });
    return res.data;
  },

  async getAllAdmissionContacts(_obj, params) {
    const res = await axios.get(`api/universities/admission-contacts/`, { params });
    return res.data;
  },

  async getAdmissionContact(_obj, id) {
    const res = await axios.get(`api/universities/admission-contacts/${id}/`);
    return res.data;
  },

  async createAdmissionContact(_obj, data) {
    return axios.post(`api/universities/admission-contacts/`, data);
  },

  async updateAdmissionContact(_obj, { id, data }) {
    return axios.patch(`api/universities/admission-contacts/${id}/`, data);
  },

  async deleteAdmissionContact(_obj, id) {
    return axios.delete(`api/universities/admission-contacts/${id}/`);
  },

  async getAllPrerequisites(_obj, params) {
    const res = await axios.get(`api/universities/prerequisites/`, { params });
    return res.data;
  },

  async createPrerequisite(_obj, data) {
    return axios.post(`api/universities/prerequisites/`, data);
  },

  async updatePrerequisite(_obj, { id, data }) {
    return axios.patch(`api/universities/prerequisites/${id}/`, data);
  },

  async deletePrerequisite(_obj, id) {
    return axios.delete(`api/universities/prerequisites/${id}/`);
  },
};

export const uni = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
